import { render } from "./tournament-card.template.html?vue&type=template&id=f02832ae&scoped=true"
import script from "./TournamentCard.vue?vue&type=script&lang=ts"
export * from "./TournamentCard.vue?vue&type=script&lang=ts"

import "./TournamentCard.vue?vue&type=style&index=0&id=f02832ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f02832ae"

export default script